import { Youtube, LayoutDashboard } from "lucide-react";
import { Link } from "react-router-dom";
import { CHANNEL_URL } from "@/constants/roles";
import { MeltoLogo } from "@/components/MeltoLogo";

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-slate-200/60 bg-white/80 shadow-sm backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
        <button
          data-testid="nav-logo-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2"
        >
          <MeltoLogo size={32} testid="nav-logo-mark" />
          <span className="font-display text-base font-semibold tracking-tight text-slate-900">
            Melto Studios
          </span>
        </button>

        <nav className="hidden items-center gap-7 md:flex">
          <button data-testid="nav-roles-link" onClick={() => scrollTo("roles")} className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900">
            Roles
          </button>
          <button data-testid="nav-pay-link" onClick={() => scrollTo("pay")} className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900">
            Pay
          </button>
          <button data-testid="nav-workflow-link" onClick={() => scrollTo("workflow")} className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900">
            Workflow
          </button>
          <button data-testid="nav-about-link" onClick={() => scrollTo("about")} className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900">
            The Channel
          </button>
        </nav>

        <div className="flex items-center gap-2.5">
          <a
            data-testid="nav-youtube-link"
            href={CHANNEL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden items-center gap-1.5 rounded-full bg-slate-100 px-4 py-2 text-xs font-semibold text-slate-700 transition-colors hover:bg-slate-200 lg:flex"
          >
            <Youtube className="h-3.5 w-3.5 text-cyan-600" />
            @ItsMelto
          </a>
          <Link
            data-testid="nav-dashboard-link"
            to="/dashboard"
            className="flex items-center gap-1.5 rounded-full bg-slate-900 px-5 py-2 text-sm font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-slate-800"
          >
            <LayoutDashboard className="h-3.5 w-3.5" />
            Dashboard
          </Link>
          <button
            data-testid="navbar-apply-button"
            onClick={() => scrollTo("apply")}
            className="rounded-full bg-cyan-500 px-5 py-2 text-sm font-semibold text-white shadow-md shadow-cyan-500/20 transition-all duration-200 hover:-translate-y-0.5 hover:bg-cyan-600 hover:shadow-cyan-500/35"
          >
            Apply
          </button>
        </div>
      </div>
    </header>
  );
};
